import { FaGithub, FaLinkedinIn, FaGlobe, FaEnvelope } from "react-icons/fa";
import { SiStackoverflow } from "react-icons/si";

// Social links, edit once, updates everywhere automatically
// Used in: Homepage banner, Contact page, Footer
export const socialLinks = [
  {
    icon: FaGithub,
    url: "https://github.com/",
    name: "GitHub",
  },
  {
    icon: FaLinkedinIn,
    url: "https://linkedin.com/",
    name: "LinkedIn",
  },
  {
    icon: FaGlobe,
    url: "https://react-portfolio-template-indol.vercel.app/",
    name: "Website",
  },
  {
    icon: FaEnvelope,
    url: "mailto:hello@amaralune.com",
    name: "Email",
  },
  {
    icon: SiStackoverflow,
    url: "https://stackoverflow.com/",
    name: "StackOverflow",
  },
];
